import { ScheduleTime } from '../../../../../@types';
import { AutocompleteTagType } from '../../../../../components/organisms/Tags';

/** The five-field cron string the schedule editor works in. */
export const toCronString = (schedule: ScheduleTime): string =>
  [schedule.minute, schedule.hour, schedule.dayOfMonth, schedule.month, schedule.dayOfWeek].join(
    ' '
  );

export const fromCronString = (cron: string): ScheduleTime => {
  const fields = cron.split(' ');
  return {
    minute: fields[0],
    hour: fields[1],
    dayOfMonth: fields[2],
    month: fields[3],
    dayOfWeek: fields[4],
  };
};

/**
 * Recipients travel over the wire as a bracketed, comma-joined string.
 *
 * The trim-and-filter is the fix for a real defect: `''` and `'[]'` both used to
 * parse to `['']`, so a schedule saved with no recipients hydrated as one blank
 * chip in the Recipients field, and that blank then satisfied the "recipients
 * required" check on the next save.
 */
export const parseRecipients = (recepients: string): string[] => {
  const trimmed = recepients.trim();
  // Only unwrap when it is actually wrapped: a bare `a@x.com` fed to an
  // unconditional `slice(1, -1)` came back as `@x.co`.
  const inner = trimmed.startsWith('[') && trimmed.endsWith(']') ? trimmed.slice(1, -1) : trimmed;
  return inner
    .split(',')
    .map((recipient) => recipient.trim())
    .filter(Boolean);
};

/**
 * The Tags field hands back either a typed tag or the raw string the user typed.
 * The old `unknown[]` signature let a tag through to template interpolation, where
 * it stringified to `[object Object]` and was posted as a recipient address.
 */
export const serialiseRecipients = (recipients: (AutocompleteTagType | string)[]): string =>
  `[${recipients.map((recipient) => (typeof recipient === 'string' ? recipient : recipient.label)).join(',')}]`;
